import { ROUTES } from '../routes';
import { loadPersistedParams, loadPersistedRoute, loadPersistedToken } from './session-storage';

const EMPTY_LIST = Object.freeze([]);
const DEFAULT_USER = Object.freeze({ id: null, name: 'Usuário', role: 'Perfil', email: '', permissions: [], debug_enabled: 'N' });

function getInitialRoute() {
  return loadPersistedRoute(ROUTES.LOGIN);
}

function getInitialParams() {
  return loadPersistedParams();
}

function getInitialTemplates() {
  return [];
}

function getInitialAuthToken() {
  return loadPersistedToken();
}

function getInitialCurrentUser() {
  return { ...DEFAULT_USER };
}

function getInitialEmptyList() {
  return [...EMPTY_LIST];
}

export {
  getInitialAuthToken,
  getInitialCurrentUser,
  getInitialEmptyList,
  getInitialParams,
  getInitialRoute,
  getInitialTemplates,
};
